export default __webpack_public_path__ + "static/media/text-field-usage.232760e0.svg";